import React from 'react';
import ActionButton from '../../action-button';
import { useEditorHeaderContext } from '../context';

const PreviewButton = ({ label, ...props }) => {
  const { isLg } = useEditorHeaderContext();

  return (
    <ActionButton
      {...props}
      label={isLg ? label : undefined}
      iconPlacement="before"
      iconGlyph={isLg ? undefined : 'eye'}
      format="solid-white"
      size="small"
      appearance="default"
    />
  );
};

export default PreviewButton;
